import MojitoModules from 'mojito/modules';
import { useOutletContext } from 'applications/common/routing/outlet-context.js';
import LeaguesFilterSection from 'applications/sports/pages/sport-page/views/leagues-filter-section/index.js';

const PrebuiltBetBuilderCoupon = MojitoModules.PrebuiltBetBuilderCoupon;

export default function PrebuiltBetsView({ mojitoTools }) {
    const { config } = mojitoTools;
    const { preBuiltBetBuilders } = useOutletContext() ?? {};
    const groupId = preBuiltBetBuilders?.group;

    return (
        <LeaguesFilterSection config={config.leaguesFilterSection} groupId={groupId}>
            {selectedLeagueId => (
                <PrebuiltBetBuilderCoupon
                    pbbbGroupId={groupId}
                    selectedGroupId={selectedLeagueId}
                    config={config.pbbbCoupon}
                />
            )}
        </LeaguesFilterSection>
    );
}
